import { graphql, useStaticQuery } from 'gatsby';

/**
 * useGraduatesData — shared hook that fetches and normalises Strapi graduates
 * data. Used by CrackedCrioCareersSection, BrochureSidebar, and
 * MobileBrochureSidebar to avoid duplicating the same query + reduce logic.
 *
 * @returns {{ name: string, companyLogo: object, profileImage: object }[]}
 */
const useGraduatesData = () => {
  const data = useStaticQuery(graphql`
    query GraduatesDataQuery {
      allStrapiGraduates {
        ...allStrapiGraduatesFragment
      }
    }
  `);

  return data.allStrapiGraduates.nodes.reduce((result, obj) => {
    if (
      obj.showInPlacementsSection &&
      obj.company &&
      obj.company.Logo &&
      obj.Photo
    ) {
      result.push({
        name: obj.Name,
        companyLogo: obj.company.Logo,
        profileImage: obj.Photo,
      });
    }
    return result;
  }, []);
};

export default useGraduatesData;
